import { render, staticRenderFns } from "./PromotionDappStepRewardForm.vue?vue&type=template&id=16be4586&scoped=true&"
import script from "./PromotionDappStepRewardForm.vue?vue&type=script&lang=js&"
export * from "./PromotionDappStepRewardForm.vue?vue&type=script&lang=js&"
import style0 from "./PromotionDappStepRewardForm.vue?vue&type=style&index=0&id=16be4586&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16be4586",
  null
  
)

export default component.exports